const DragDropVerticalIcon = /*#__PURE__*/ [
  ["path", { d: "M8 6H8.00635M8 12H8.00635M8 18H8.00635M15.9937 6H16M15.9937 12H16M15.9937 18H16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2.5", key: "0" }]
];

export { DragDropVerticalIcon as default };
//# sourceMappingURL=DragDropVerticalIcon.js.map
